module.exports = __webpack_public_path__ + "static/media/gcp_logo.ba18401b.png";